import { Card, Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSnowflake, faHome, faCapsules, faFlask } from '@fortawesome/free-solid-svg-icons'
import './Works.css'


const Works = ({ filter }) => {
    return(
        <main className='works' id='works'>
            <Container>
                <h2>Pulsa sobre cualquier botón para ver lo que te ofrecemos</h2>
                <Row className='justify-content-center align-items-center' xs={2} md={3} xl={5}>
                    <Col>
                        <Card onClick={() => filter('Frio')}>
                            <FontAwesomeIcon icon={faSnowflake} />
                            <h3>Frío Industrial</h3>
                        </Card>
                    </Col>
                    <Col>
                        <Card onClick={() => filter('Laboratorio')}>
                            <FontAwesomeIcon icon={faFlask} />
                            <h3>Laboratorio</h3>
                        </Card>
                    </Col>
                    <Col>
                        <Card onClick={() => filter('Farmacia')}>
                            <FontAwesomeIcon icon={faCapsules} />
                            <h3>Farmacia</h3>
                        </Card>
                    </Col>
                    <Col>
                        <Card onClick={() => filter('Clima')}>
                            <FontAwesomeIcon icon={faHome} />
                            <h3>Climatización</h3>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default Works